// src/components/dashboard/SlideOutPanel.jsx
import React from 'react';
import { X } from 'lucide-react';

const SlideOutPanel = ({ isOpen, onClose, title, children, wide = false }) => {
  // Determine width classes based on wide prop
  const widthClasses = wide 
    ? 'w-full md:w-[70%] lg:w-[75%]' // Wider for exam analytics
    : 'w-full md:w-[42%]'; // Default width

  return (
    <>
      {/* Blurred Backdrop */}
      <div
        className={`fixed inset-0 transition-all duration-500 z-40 ${
          isOpen 
            ? 'backdrop-blur-md bg-black/30 opacity-100' 
            : 'backdrop-blur-none opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Slide Panel */}
      <div
        className={`fixed top-0 right-0 h-full bg-white shadow-2xl transition-transform duration-500 ease-out z-50 border-l-[3px] border-black ${
          isOpen ? `translate-x-0 ${widthClasses}` : `translate-x-full ${widthClasses}`
        }`}
        style={{
          boxShadow: '-10px 0 60px rgba(0, 0, 0, 0.3)'
        }}
      >
        <div className="h-full flex flex-col">
          {/* Panel Header - Black with decorations */}
          <div className="relative bg-black text-white p-6 md:p-8 flex justify-between items-center flex-shrink-0 overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-5 rounded-full transform -translate-y-16 translate-x-16" />

            {/* Corner decorations */}
            <div className="absolute top-3 left-3 w-5 h-5 border-t-2 border-l-2 border-white/20" />
            <div className="absolute bottom-3 right-3 w-5 h-5 border-b-2 border-r-2 border-white/20" />

            <h2 className="relative z-10 font-space text-xl md:text-2xl font-black tracking-tight">{title}</h2>
            <button
              onClick={onClose}
              className="relative z-10 group w-10 h-10 md:w-12 md:h-12 bg-white/10 hover:bg-[#3A86FF] rounded-xl flex items-center justify-center transition-all duration-300 border border-white/20 hover:scale-110 hover:rotate-90"
              aria-label="Close panel"
            >
              <X className="w-5 h-5 md:w-6 md:h-6" />
            </button>

            {/* Shine effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
          </div>

          {/* Panel Content - Scrollable with custom scrollbar */}
          <div
            className="flex-1 overflow-y-auto p-6 md:p-8 space-y-6 bg-gray-50"
            style={{
              scrollbarWidth: 'thin',
              scrollbarColor: '#3A86FF #f3f4f6'
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default SlideOutPanel;